import { motion } from 'framer-motion'
import { Button } from '@/components/ui/button'

interface QuickRepliesProps {
  replies: string[]
  onSelect: (reply: string) => void
}

export function QuickReplies({ replies, onSelect }: QuickRepliesProps) {
  if (replies.length === 0) return null

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2, delay: 0.1 }}
      className="flex flex-wrap gap-2 pl-9"
    >
      {replies.map((reply) => (
        <Button
          key={reply}
          variant="outline"
          size="sm"
          className="h-7 rounded-full border-border/60 text-xs text-muted-foreground hover:text-foreground hover:border-primary/40 hover:bg-primary/5 transition-colors"
          onClick={() => onSelect(reply)}
        >
          {reply}
        </Button>
      ))}
    </motion.div>
  )
}
